var Pixel = Pixel || {};

Pixel.Pinterest = (function (PixelBase) {
    var Pinterest = PixelBase.extend({
        initialize: function (opts) {
            opts = opts || {};
            this._currency = opts.currency;
            this._getAPI()('load', this._id);
        },

        pageView: function () {
            this._getAPI()('page');
            this._getAPI()('track', 'pagevisit');
        },

        _getAPI: function () {
            return window.pintrk || function() {};
        },

        purchaseSuccess: function (opts) {
            var data = opts.OrderInfoResult || {};

            var items = [];

            var totalQuantity = 0;

            if (data.Items) {
                $.each(data.Items, function () {
                    totalQuantity += this.Quantity;

                    var unitPrice = parseFloat(this.Price) || this.Price;
                    items.push({
                        product_quantity: this.Quantity,
                        product_price: unitPrice,
                        product_id: this.Sku,
                        product_name: this.ProductName
                    });
                });
            }

            this._getAPI()('track', 'checkout', {
                value: data.Total,
                order_quantity: totalQuantity,
                currency: this._currency,
                line_items: items
            });
        }
    });

    return Pinterest;
})(Pixel.PixelBase);

!function (Pixel, GlobalSettings) {
    if (!GlobalSettings.PID) {
        return;
    }

    (function (e) {
        if (!window.pintrk) {
            window.pintrk = function () {
                window.pintrk.queue.push(
                    Array.prototype.slice.call(arguments))
            };
            var n = window.pintrk; n.queue = [], n.version = "3.0";
            var t = document.createElement("script"); t.async = !0, t.src = e;
            var r = document.getElementsByTagName("script")[0]; r.parentNode.insertBefore(t, r)
        }
    })("https://s.pinimg.com/ct/core.js");

    new Pixel.Pinterest({
        id: GlobalSettings.PID
    });
}(Pixel, GlobalSettings);
